import { equalizeHeightByOffset, isMobile, onDelegatedClick }  from './functions.js';

export default function CarCarouselModule(element) {

    let qs = element.querySelector.bind(element);
    let qsa = element.querySelectorAll.bind(element);

    let arrowLeft  = qs('.carpages__arrow--left');
    let arrowRight = qs('.carpages__arrow--right');

    let carsContainer = qs('.car__container');

    equalizeHeightByOffset('.car__title', {margin: 5});

    setTimeout(function() {
        equalizeHeightByOffset('.car__data', {margin: 5});
    }, 1000);

    let scrollSize = qs('.car').offsetWidth + 10;

    arrowRight.addEventListener('click', event => {
        event.preventDefault();
        carsContainer.scrollBy({
            left: scrollSize,
            top: 0,
            behavior: 'smooth'
        });
    });
    
    arrowLeft.addEventListener('click', event => {
        event.preventDefault();
        carsContainer.scrollBy({
            left: scrollSize * -1,
            top: 0,
            behavior: 'smooth'
        });
    });

    let lastScrollLeft = 0;

    let scrollTimeout = null;
    carsContainer.addEventListener('scroll', event => {
        // console.log('scroll');

        clearTimeout(scrollTimeout);

        scrollTimeout = setTimeout(() => {
            console.log('onScrollEnded');
            onScrollEnded();
        }, 400);
    });

    function onScrollEnded() {
        refreshArrows();

        let absDiff = Math.abs(carsContainer.scrollLeft - lastScrollLeft);

        lastScrollLeft = carsContainer.scrollLeft;

        let isSignificantScroll = absDiff > 20;

        if (isSignificantScroll && isMobile()) {

            console.log('onScrollEnded && isSignificantScroll && isMobile()');

            let firstVisibleCar = [...qsa('.car')].find(element => {
                return element.offsetLeft >= carsContainer.scrollLeft;
            });

            if (!firstVisibleCar) { return; }

            if (firstVisibleCar.classList.contains('active')) { 
                return; 
            }

            resultsPage1.changeCar(firstVisibleCar.dataset.href, firstVisibleCar.dataset.carId);
            
        }
    }

    // carsContainer.addEventListener('scrollend', event => {
    //     onScrollEnded();
    // });

    function refreshArrows() {
        if (carsContainer.scrollLeft > 0) {
            arrowLeft.classList.remove('disabled');
        } else {
            arrowLeft.classList.add('disabled');
        }

        let maxScrollLeft = carsContainer.scrollWidth - carsContainer.clientWidth;
        
        if (carsContainer.scrollLeft < maxScrollLeft) {
            arrowRight.classList.remove('disabled');
        } else {
            arrowRight.classList.add('disabled');
        }
    }
    
    refreshArrows();
}
